import { entityEditorRoute } from '@/modules/entity/router';

entityEditorRoute.adPosition = (entityType, entity) => ({
  name: 'entity.editor',
  params: {
    entity: entity.type,
    id: entity.id,
  },
});
